export default [
  {
    path: "/batch-operation-tool",
    name: "batch-operation-tool",
    meta: { title: "Batch Operation tool" },
    component: () => import("../views/tool/batch-operation-tool.vue"),
  },
];
